import { useRef, useState } from "react";

export function useFailedChatInputs() {
    const failedInputIdsRef = useRef(new Set<string>());
    const [failedInputIds, setFailedInputIds] = useState<ReadonlySet<string>>(
        new Set(),
    );

    function markFailed(inputIds: string[]) {
        const next = new Set([...failedInputIdsRef.current, ...inputIds]);
        failedInputIdsRef.current = next;
        setFailedInputIds((current) =>
            current.size === next.size &&
            [...next].every((id) => current.has(id))
                ? current
                : new Set(next),
        );
    }

    function clearFailed(inputIds: string[]) {
        const next = new Set(failedInputIdsRef.current);
        for (const inputId of inputIds) next.delete(inputId);
        failedInputIdsRef.current = next;
        setFailedInputIds(new Set(next));
    }

    return { failedInputIds, failedInputIdsRef, markFailed, clearFailed };
}
